import { useParams } from "react-router-dom";
import Layout from "../layout";
import { ToolsProvider } from "@my-helpers/common";
import ToolView from "./tool";
import ToolsView from "./tools";

const Tools = () => {
    const { id } = useParams<{ id: string }>();

	return (
		<Layout>
			<ToolsProvider toolId={id} >
                {
                    id ? 
                    <ToolView /> :
                    <ToolsView />
                }
			</ToolsProvider>
		</Layout>
	);
};

export default Tools;